export default __webpack_public_path__ + "static/media/AppraiseePersona.a448deb3.png";